import { render, staticRenderFns } from "./AccordionStudentHistory.vue?vue&type=template&id=017014fc&scoped=true&lang=pug&"
import script from "./AccordionStudentHistory.vue?vue&type=script&lang=ts&"
export * from "./AccordionStudentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionStudentHistory.vue?vue&type=style&index=0&id=017014fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017014fc",
  null
  
)

export default component.exports